import { RemoteAddSmartcards } from "../../../../data/usecases/smartcard";
import { AddSmartcards } from "../../../../domain/usecases/add-smartcards";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAddSmartcards = (): AddSmartcards =>
  new RemoteAddSmartcards(
    makeApiUrl("/smartcards/add-smartcards"),
    makeAxiosHttpClient()
  );
